import { Grid, Typography } from '@mui/material';
import { useSwichFunctionaryInfo } from './hook';
import { FunctionaryInfoProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import RichText from '../../../../../components/richText';
import FieldText from '../../../../../components/general/fields/fieldText';
import { isNoSelected } from './formData';

export default function SwitchFunctionaryInfo(props: FunctionaryInfoProps) {
    const { formik, areas, functionaries } = useSwichFunctionaryInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información funcionario{' '}
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Correo funcionario"
                    name="emailFunctionary"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.emailFunctionary}
                    errors={formik.errors.emailFunctionary}
                    value={formik.values.emailFunctionary as string}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    label="Área"
                    name="area"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.area}
                    errors={formik.errors.area}
                    value={formik.values.area as any}
                    onChangeValue={(value: any) => {
                        formik.setFieldValue('functionary', '');
                        //formik.setFieldValue('emailFunctionary', '');
                        formik.setFieldValue('functionaryExtension', '');
                        formik.setFieldValue('functionaryAttendedCall', '');

                        formik.setFieldValue('area', value);
                    }}
                    data={areas ?? []}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    label="Funcionario"
                    name="functionary"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.functionary}
                    errors={formik.errors.functionary}
                    value={formik.values.functionary as any}
                    data={functionaries ?? []}
                    getOptionLabel={(o: any) => o?.label ?? o?.name ?? ''}
                    defineValue="object"
                    onChangeValue={(fn: any) => {
                        if (!fn) {
                            formik.setFieldValue('functionary', '');
                            formik.setFieldValue('emailFunctionary', '');
                            formik.setFieldValue('functionaryExtension', '');
                            return;
                        }
                        formik.setFieldValue('functionary', fn.id);
                        formik.setFieldValue(
                            'emailFunctionary',
                            fn.email ?? ''
                        );
                        formik.setFieldValue(
                            'functionaryExtension',
                            fn.extension ?? ''
                        );
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Extensión funcionario"
                    name="functionaryExtension"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.functionaryExtension}
                    errors={formik.errors.functionaryExtension}
                    value={formik.values.functionaryExtension as string}
                    onChange={(value: any) =>
                        formik.setFieldValue('functionaryExtension', value)
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    label="¿Se logró contactar al funcionario?"
                    name="functionaryAttendedCall"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.functionaryAttendedCall}
                    errors={formik.errors.functionaryAttendedCall}
                    value={formik.values.functionaryAttendedCall as any}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('functionaryAttendedCall', value)
                    }
                    data={[
                        { id: 'si', name: 'Si' },
                        { id: 'no', name: 'No' },
                    ]}
                />
            </Grid>

            {isNoSelected(formik.values.functionaryAttendedCall) && (
                <Grid item xs={12}>
                    <RichText
                        initialContent={formik.values.templateEmail}
                        editable
                        onContentChange={(value) =>
                            formik.setFieldValue('templateEmail', value)
                        }
                    />
                </Grid>
            )}
        </Grid>
    );
}
